/**
 * Determines the current site mode based on hostname.
 *
 * - biz.omore.app     → 'kid'    (Launchpad, Spotlight, etc.)
 * - parent.omore.app  → 'parent' (Parent Portal)
 * - localhost / other → 'kid'    (default for dev)
 */
export type SiteMode = 'kid' | 'parent';

export const PORTAL_URL = 'https://parent.omore.app';

export function getSiteMode(): SiteMode {
  const host = window.location.hostname;
  // staging-portal kept for backward-compat with the pre-rename staging subdomain.
  if (
    host === 'parent.omore.app' ||
    host.startsWith('staging-parent') ||
    host.startsWith('staging-portal')
  ) {
    return 'parent';
  }
  return 'kid';
}
